import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addressCommaToLineBreak',
  standalone: false,
})
export class AddressCommaToLineBreakPipe implements PipeTransform {
  transform(value: string): string {
    const lines = value.split(',');
    const lastLine = (lines.pop() ?? '').trim();
    const result = lines.map(line => line.trim()).join('\n');
    return result + (result ? ', ' : '') + lastLine;
  }
}
